import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/services`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/services/${id}`, options)
        .then(response => {
            let service = jsona.deserialize(response.data);
            delete service.links;
            return service;
        });
}

function add(service) {
    const payload = jsona.serialize({
        stuff: service,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/services`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function multipleAdd(deviceFirmwareVersion) {
    // const payload = jsona.serialize({
    //     stuff: deviceFirmwareVersion,
    //     includeNames: null
    // });
    const payload = deviceFirmwareVersion;

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/services/multiple-add`, payload, options)
        .then(response => {
            return response.data;
        });
}

function update(service) {
    const payload = jsona.serialize({
        stuff: service,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/services/${service.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/services/${id}`, options);
}

export default {
    list,
    get,
    add,
    multipleAdd,
    update,
    destroy
};